<template>
  <div class="datamatrix-container">
    <canvas
      ref="datamatrixCanvas"
      v-b-tooltip.hover.bottom
      alt="Datamatrix code"
      :style="{
        width,
        height,
        backgroundColor: 'white',
        border: '5px solid #fff',
      }"
      :title="noTooltip ? undefined : encodeString"
      @click.stop.prevent="emulateKeyboardScan"
    />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import bwipjs from 'bwip-js';

export default {
  name: 'Datamatrix',
  props: {
    encodeString: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: '45px',
    },
    height: {
      type: String,
      default: '45px',
    },
    noTooltip: Boolean,
  },
  watch: {
    encodeString: {
      handler() {
        this.generateDatamatrix();
      },
    },
  },
  methods: {
    generateDatamatrix() {
      const canvas = this.$refs.datamatrixCanvas;
      bwipjs.toCanvas(canvas, {
        bcid: 'datamatrix',
        text: this.encodeString,
        scale: 3,
        includetext: false,
      }, err => {
        if (err) {
          throw err;
        }
      });
    },
    emulateKeyboardScan() {
      const scancode = this.encodeString.split('').map(char => char.charCodeAt(0));
      scancode.push(13); // End of line \r

      scancode.forEach((code, index) => {
        setTimeout(() => {
          const event = new KeyboardEvent('keydown', {
            keyCode: code,
            code: String.fromCharCode(code),
            key: String.fromCharCode(code),
          });
          document.dispatchEvent(event);
        }, index * 1);
      });
    },
  },
  mounted() {
    this.generateDatamatrix();
  },
};
</script>

<style scoped>
.datamatrix-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
